<template>
  <div>
    <div class="container article-container hidden-xs">
      <h3 v-if="articleDetail.title">{{ articleDetail.title }}</h3>
      <div class="p-title-div" v-if="articleDetail.title">
      </div>
      <div class="flex" v-if="articleDetail.title">
        <div class="left">
          <div class="article">
            <div v-html="articleDetail.content"></div>
          </div>
          <div style="width: 100%;text-align: center">
            <el-button type="text" @click="goMore('ContactUs')">
              {{ $t('home.more') }}
              <i class="el-icon-arrow-right el-icon--right"></i>
            </el-button>
          </div>
        </div>
        <div class="right hidden-xs">
          <img class="article-pic" :src="articleDetail.blogPic" v-if="showImg"/>
        </div>
      </div>
    </div>
    <div class="container article-container visible-xs">
      <h3 v-if="articleDetail.title">{{ articleDetail.title }}</h3>
      <div class="p-title-div" v-if="articleDetail.title">
      </div>
      <div class="snip-container-xs snip-table-item-xs "
           @click="goMore('ContactUs')"
      >
        <div class="left-img-xs">
          <img :src="articleDetail.blogPic"/>
        </div>
        <div class="right-div-xs">
          <div class="title" v-html="articleDetail.content">
          </div>
        </div>
      </div>
      <div style="width: 100%;text-align: center">
        <el-button type="text" @click="goMore('ContactUs')">
          {{ $t('home.more') }}
          <i class="el-icon-arrow-right el-icon--right"></i>
        </el-button>
      </div>
    </div>
  </div>


</template>
<script>
import api from "../api/api";

export default {
  name: 'articleDetailLeft',
  components: {},
  //menu  主要需要typeId
  props: {
    typeId: {
      type: Number,
      default: null
    },
    showImg: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      tags: [],
      activeName: '',
      articleDetail: {}
    }
  },
  watch: {
    typeId: {
      handler(newVal) {
        this.getData()
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.articleDetail = {}
      api.getAriticle({language: this.$store.state.lang, typeId: this.typeId}).then(res => {
        let list = res.data.data
        if (list && list.length > 0) {
          this.articleDetail = list[0]
          this.articleDetail.content = this.replaceImgStyle(this.articleDetail.content)
        }
      })
    },
    replaceImgStyle(str) {
      // return str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g,'').replace(/&nbsp;/ig,'').replace('<p></p>','');
      return str.replace('<img ', '<img style=" max-width: 100%; margin: auto;" ');
    },
  }
}
</script>
<style scoped>
.article-container {
  margin-top: 20px;
  padding: 0 0 20px 0;
}

.p-title-div {
  margin: 15px
}

.article-pic {
  width: 100%;
}

.article {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.article > div {
  margin: 20px 0 0 0;
  width: 100%;
  /*height: 18vw;*/
  font-size: 18px;
  line-height: 30px;
  font-family: MicrosoftYaHei;
  text-align: left;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-break: break-all;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 8;
}

.left {
  flex: 1;
}

.right {
  flex: 1;
  padding-left: 10px;
}

@media screen and (max-width: 997px) {
  .article-container {
    margin-top: 10px;
    font-size: 14px;
    padding: 10px 20px;
  }

  .article > div {
    margin: 10px 0 0 0;
    font-size: 14px;
    line-height: 20px;
    -webkit-line-clamp: 5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/articleDetailLeft.vue